export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4639.70ecf38e.jpg";